export default __webpack_public_path__ + "960e8d84d153f7620dd2608c929f0037.jpg";